import cn from "classnames";

import styles from "./PaginationControls.module.css";

const PAGE_SIZES = [15, 25, 50];

// Monta a sequência de páginas a exibir, colapsando faixas longas em "…".
// Sempre inclui a primeira, a última e a página atual com um vizinho de cada lado.
function getPageItems(page, totalPages) {
  const items = [];
  const delta = 1;
  let last = 0;

  for (let i = 1; i <= totalPages; i += 1) {
    const isEdge = i === 1 || i === totalPages;
    const isNear = i >= page - delta && i <= page + delta;
    if (!isEdge && !isNear) continue;

    if (last && i - last > 1) {
      items.push({ type: "ellipsis", key: `ellipsis-${last}` });
    }
    items.push({ type: "page", value: i, key: `page-${i}` });
    last = i;
  }

  return items;
}

const PaginationControls = ({
  page,
  totalPages,
  totalResult,
  limit,
  loading,
  onPageChange,
  onLimitChange,
}) => {
  const currentPage = totalPages === 0 ? 0 : page;
  const canPrev = page > 1 && !loading;
  const canNext = page < totalPages && !loading;

  const pageItems = getPageItems(page, totalPages);
  const formattedTotal = Number(totalResult ?? 0).toLocaleString("pt-BR");
  const resultWord = totalResult === 1 ? "resultado" : "resultados";

  return (
    <div className={styles.bar}>
      <div className={styles.status} role="status" aria-live="polite">
        <span className={styles.count}>
          <strong className={styles.countNum}>{formattedTotal}</strong> {resultWord}
        </span>
        <span className={styles.pageInfo}>
          Página {currentPage} de {totalPages}
        </span>
      </div>

      <div className={styles.controls}>
        <label className={styles.sizeGroup}>
          <span className={styles.sizeLabel}>Itens por página</span>
          <select
            className={styles.select}
            value={limit}
            onChange={(e) => onLimitChange(Number(e.target.value))}
            disabled={loading}
            aria-label="Itens por página"
          >
            {PAGE_SIZES.map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
        </label>

        <nav className={styles.pager} aria-label="Paginação">
          <button
            type="button"
            className={styles.navBtn}
            disabled={!canPrev}
            onClick={() => onPageChange(page - 1)}
          >
            <i className="fas fa-chevron-left" aria-hidden="true" />
            Anterior
          </button>

          <span className={styles.numbers}>
            {pageItems.map((item) =>
              item.type === "ellipsis" ? (
                <span key={item.key} className={styles.ellipsis} aria-hidden="true">
                  …
                </span>
              ) : (
                <button
                  key={item.key}
                  type="button"
                  className={cn(styles.pageBtn, {
                    [styles.pageActive]: item.value === currentPage,
                  })}
                  aria-label={`Página ${item.value}`}
                  aria-current={item.value === currentPage ? "page" : undefined}
                  disabled={loading || item.value === currentPage}
                  onClick={() => onPageChange(item.value)}
                >
                  {item.value}
                </button>
              )
            )}
          </span>

          <button
            type="button"
            className={styles.navBtn}
            disabled={!canNext}
            onClick={() => onPageChange(page + 1)}
          >
            Próxima
            <i className="fas fa-chevron-right" aria-hidden="true" />
          </button>
        </nav>
      </div>
    </div>
  );
};

export default PaginationControls;
